module.exports = __webpack_public_path__ + "static/media/shah.0076863d.jpeg";